import { IUser } from '../features/users/types';

export interface IAuth {
  token_type: 'Bearer';
  access_token: string;
  refresh_token: string;
  expires_in: number;
}

export interface IAuthState {
  isLoggedIn: boolean;
  auth?: Partial<IAuth>;
  user?: IUser & {
    meta: {
      permissions: { id: string; name: string }[];
      merchant?: { id: string; name: string };
      customer?: {
        id: string;
        has_wallet: boolean;
        wallet_token: string;
        wallet_type: string;
      };
    };
  };
}

export type TSignInArgs = {
  username: string;
  password: string;
};

export interface IPermissionValue {
  title: string;
  value: string;
  disabled: boolean;
}

export enum PermissionName {
  SUBSCRIPTION_START = 'SUBSCRIPTION_START',
  SUBSCRIPTION_END = 'SUBSCRIPTION_END',
  STAFF_ASSIGN_OFFERS = 'STAFF_ASSIGN_OFFERS',
  REWARD_REDEEM = 'REWARD_REDEEM',
  NAV_USER = 'NAV_USER',
  NAV_STAFF = 'NAV_STAFF',
  NAV_NOTIFICATIONS = 'NAV_NOTIFICATIONS',
  NAV_MERCHANTS = 'NAV_MERCHANTS',
  NAV_EVENTS = 'NAV_EVENTS',
  NAV_CUSTOMERS = 'NAV_CUSTOMERS',
  NAV_CATEGORIES = 'NAV_CATEGORIES',
  MERCHANT_RESET_USER = 'MERCHANT_RESET_USER',
  MERCHANT_EXPORT_REPORT = 'MERCHANT_EXPORT_REPORT',
  EVENT_STATISTICS = 'EVENT_STATISTICS',
  EVENT_REPORTING = 'EVENT_REPORTING',
  EVENT_CHECKOUT = 'EVENT_CHECKOUT',
  EVENT_CHECKIN = 'EVENT_CHECKIN',
  CUSTOMER_SEND_OFFER = 'CUSTOMER_SEND_OFFER',
  NAV_APP_BANNERS = 'NAV_APP_BANNERS',
  NAV_PROMO_CODES = 'NAV_PROMO_CODES',
  CUSTOMER_MANAGE_ACTION = 'CUSTOMER_MANAGE_ACTION',
  CUSTOMER_TOGGLE_STATUS = 'CUSTOMER_TOGGLE_STATUS',
  EXPORT_CUSTOMERS_BUTTON = 'EXPORT_CUSTOMERS_BUTTON',
  EXPORT_CIB_USERS_BUTTON = 'EXPORT_CIB_USERS_BUTTON',
}
